<div>
    <form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
            <div class="form-group row">
                <div class="col-md-12 col-12">
                    <yt-dropdown-picklist
                        [ModelName]="'podvrstadokumentastavka'"
                        [GetName]="'GetUplataByDinIzvod'"
                        [ModelProperty]="'Sifra,Naziv'"
                        [GetParameters]="PodVrstaDokumentaStavkaGetParameters"
                        formControlName="PodVrstaDokumentaStavkaID" [Label]="'IZVOD.PODVRSTADOKUMENTASTAVKA.SINGULAR'"
                        #autofocus [ngClass]="{'is-invalid': submitted && fc.PodVrstaDokumentaStavkaID.invalid}"
                        (OnItemSelected)='onPodVrstaSelect()' [Width]="'600px'" [AutoSelect]="true">
                    </yt-dropdown-picklist>
                    <div class="form-error" *ngIf="submitted && fc.PodVrstaDokumentaStavkaID.invalid">
                        <span *ngFor="let validation of errorMessages.PodVrstaDokumentaStavkaID">
                            <span class="error-message"
                                *ngIf="fc.PodVrstaDokumentaStavkaID.hasError(validation.type)"><span
                                    translate="{{validation.message}}"></span></span>
                        </span>
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-md-12">
                    <yt-fw-date-picker-popup #dtpDatum formControlName="Datum" name="txtDatum"
                        [Label]="'FAKDOKUMENTUPLATA.DATUM.SINGULAR'"
                        [ngClass]="{ 'is-invalid': submitted && fc.Datum.invalid }"
                        (OnDateSelected)="onDatumChange($event)">
                    </yt-fw-date-picker-popup>
                    <div class="form-error" *ngIf="submitted && fc.Datum.invalid">
                        <span *ngFor="let validation of errorMessages.Datum">
                            <span class="error-message" *ngIf="fc.Datum.hasError(validation.type)"><span
                                    translate="{{ validation.message }}"></span></span>
                        </span>
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <div class="col-md-4 col-4">
                    <yt-input [Type]="'text'" [Label]="('FAKDOKUMENTUPLATA.BROJIZVODBANKE.SINGULAR' | translate)" formControlName="Broj"
                        [ngClass]="{'is-invalid': submitted && fc.Broj.invalid}">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.Broj.invalid">
                        <span *ngFor="let validation of errorMessages.Broj">
                            <span class="error-message" *ngIf="fc.Broj.hasError(validation.type)"><span
                                    translate="{{validation.message}}"></span></span>
                        </span>
                    </div>
                </div>
                <div class="col-md-4 col-4">
                    <div class="input-group-append">
                        <span class="span-control">/</span><span *ngIf="baseFormGroup.get('Datum').value != null"
                            class="span-control">{{baseFormGroup.get('Datum').value.year}}</span>
                    </div>
                </div>
                <div class="col-md-4">
                    <yt-number-input-v3
                        #autofocus
                        name="txtRB"                                 
                        [Label]="'IZVODSTAVKA.RB.SINGULAR'" 
                        formControlName="RB"
                        [FormatString]="'1.0-0'"   
                        >
                    </yt-number-input-v3>
                    <div class="form-error" *ngIf="submitted && fc.RB.invalid">
                        <span *ngFor="let validation of errorMessages.RB">
                          <span class="error-message" *ngIf="fc.RB.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                </div>

            </div>



            <div class="form-group row">
                <div class="col-md-12">
                    <yt-number-input-v3
                        name="txtIznos"
                        [Label]="('FAKDOKUMENTUPLATA.IZNOSUPLATE.SINGULAR' | translate)"
                        formControlName="Iznos"
                        [FormatString]="'1.2-2'"
                    >
                    </yt-number-input-v3>
                 <div class="form-error" *ngIf="submitted && fc.Iznos.invalid">
                        <span *ngFor="let validation of errorMessages.Iznos">
                          <span class="error-message" *ngIf="fc.Iznos.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                </div>
            </div>



    </form>
</div>